import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/users/$id/edit')({
  component: UserEditPage,
})

function UserEditPage() {
  const { id } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="space-y-6">
            <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 pb-4">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                  Edit User
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mt-2">
                  Update user information and settings
                </p>
              </div>
              <Link
                to="/users/$id"
                params={{ id }}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
              >
                Cancel
              </Link>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                Editing User ID:
              </p>
              <code className="text-lg font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100">
                {id}
              </code>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Edit Form (To be implemented)
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-400">
                <li>Personal information fields (name, email, phone)</li>
                <li>Role and permission selection</li>
                <li>Account status toggles</li>
                <li>Form validation with React Hook Form</li>
                <li>Save and cancel actions</li>
              </ul>
            </div>

            <div className="flex gap-4 pt-4 border-t border-gray-200 dark:border-gray-700">
              <button className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
                Save Changes
              </button>
              <Link
                to="/users/$id"
                params={{ id }}
                className="px-6 py-2 bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
